import React from 'react';
import { getPropertyAddress } from '@/utils/properties';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import dashedSquare from '@/assets/images/dashed_square.svg';

const HousingProfessionals = ({
  allProperties,
  propertyCompanyStats,
  dashboardLinkPrefix,
}) => {
  return (
    <div className="flex flex-col gap-1">
      <h3 className="font-medium text-xl text-foreground">Boligens fagfolk</h3>
      {propertyCompanyStats?.some((el) => el.companyCount > 0) ? (
        <>
          <p className="text-[15px] mb-1">
            Totalt{' '}
            <b>
              {propertyCompanyStats.reduce(
                (acc, obj) => acc + (Number(obj?.companyCount) || 0),
                0
              )}{' '}
              bedrifter
            </b>{' '}
            har jobbet på dine boliger
          </p>
          <div
            className={`flex flex-col md:grid ${
              allProperties.length === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'
            } rounded md:border overflow-hidden md:bg-[#dfdfdf] gap-[1px]`}
          >
            {allProperties.map((property, index) => (
              <div
                className={clsx(
                  allProperties.length !== 3 &&
                    index === allProperties.length - 1 &&
                    allProperties.length % 2 !== 0 &&
                    'col-span-2',
                  'flex px-0 md:px-5 py-2.5 md:py-5 md:bg-white w-full gap-3'
                )}
              >
                <div className="flex items-center justify-center gap-3 border rounded bg-[#E6E6E645] w-[40px] h-[40px]">
                  {(propertyCompanyStats &&
                    propertyCompanyStats.find(
                      (el) => el.boligmappaNumber === property.boligmappaNumber
                    )?.companyCount) ||
                    0}
                </div>
                <div className="flex flex-col max-w-[calc(100%-52px)]">
                  <Link
                    to={`/dashboard/${property?.boligmappaNumber}/home`}
                    className="flex items-center"
                  >
                    <h4 className="text-[15px] text-black overflow-hidden text-ellipsis whitespace-nowrap">
                      {getPropertyAddress(property)}
                    </h4>
                    <span className="ml-1">›</span>
                  </Link>
                  <p className="text-[15px] text-[#7A7A7A]">
                    {(propertyCompanyStats &&
                      propertyCompanyStats.find(
                        (el) =>
                          el.boligmappaNumber === property.boligmappaNumber
                      )?.companyCount) ||
                      0}{' '}
                    bedrifter
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <p className="text-[15px] mb-1">
            Her er oversikten over alle som har jobbet på din bolig.
          </p>
          <div className="flex flex-col gap-2 items-center border rounded py-7">
            <img width={24} height={24} alt="no companies" src={dashedSquare} />
            <p className="max-w-[280px] text-center text-black text-[15px] opacity-65">
              Her er det tomt. Husk at du kan{' '}
              <Link
                to={`${dashboardLinkPrefix}/create-mdr`}
                className="underline"
              >
                etterspørre dokumentasjon
              </Link>{' '}
              fra bedrifter.
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default HousingProfessionals;
